import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "../components/site/Logo";
import { useAuth } from "./AuthContext";
import { formatApiError } from "../lib/api";
import { useSeo } from "../components/site/Layout";

export default function AdminLogin() {
  useSeo("Espace administrateur", "Connexion à l'espace d'administration Habitalys.");
  const { user, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to={loc.state?.from || "/admin"} replace />;
  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); nav(loc.state?.from || "/admin", { replace: true }); }
    catch (err) { setError(err.response?.status === 401 ? "Identifiants incorrects" : formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };
  return (
    <div className="min-h-screen bg-navy grain relative flex items-center justify-center p-5">
      <form onSubmit={submit} className="relative z-10 w-full max-w-md rounded-[28px] bg-white p-8 sm:p-10 space-y-6" data-testid="admin-login-form">
        <Logo />
        <div>
          <h1 className="text-3xl flex items-center gap-2"><Lock className="h-6 w-6 text-brand-ink" aria-hidden="true" /> Espace admin</h1>
          <p className="mt-2 text-slate-600">Accès réservé à l'équipe Habitalys.</p>
        </div>
        <div>
          <label htmlFor="admin-email" className="block font-semibold text-navy mb-2">Email</label>
          <input id="admin-email" type="email" required className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" data-testid="admin-login-email" />
        </div>
        <div>
          <label htmlFor="admin-password" className="block font-semibold text-navy mb-2">Mot de passe</label>
          <input id="admin-password" type="password" required className="field-input" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" data-testid="admin-login-password" />
        </div>
        {error && <p role="alert" className="rounded-xl bg-red-50 text-red-800 p-3 font-medium" data-testid="admin-login-error">{error}</p>}
        <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="admin-login-submit">
          {loading && <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />} Se connecter
        </button>
      </form>
    </div>
  );
}
